import axios from 'axios';
import { getCurrentIdToken } from '../firebase/authHelpers';
import { toast } from 'react-toastify';

// Cross-origin session cookies (UI and API on different origins) require this.
axios.defaults.withCredentials = true;

let refreshPromise = null;

/**
 * Set up axios interceptor to attach Firebase ID token
 * Must be called after Firebase is initialized
 */
export const setupAxiosInterceptor = (store) => {
  // Request interceptor: add Firebase ID token to all requests
  axios.interceptors.request.use(
    async (config) => {
      const token = await getCurrentIdToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor: handle 401 errors with automatic token refresh
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Handle 401 Unauthorized
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        // Prevent concurrent refresh attempts
        if (refreshPromise) {
          const token = await refreshPromise;
          if (token) {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axios(originalRequest);
          }
        }

        // Attempt to refresh token
        refreshPromise = getCurrentIdToken(true);
        const newToken = await refreshPromise;
        refreshPromise = null;

        if (newToken) {
          // Token refreshed successfully, retry original request
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axios(originalRequest);
        } else {
          // Token refresh failed, logout user
          store.dispatch({ type: 'auth/setLoggedIn', payload: false });
          toast.error('Session expired. Please log in again.');
        }
      }

      return Promise.reject(error);
    }
  );
};
